import { render } from "./DeleteGroupModal.vue?vue&type=template&id=7265510c&scoped=true"
import script from "./DeleteGroupModal.vue?vue&type=script&lang=js"
export * from "./DeleteGroupModal.vue?vue&type=script&lang=js"

import "./DeleteGroupModal.vue?vue&type=style&index=0&id=7265510c&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7265510c"]])

export default __exports__